<template>
  <b-row>
    <b-col>
      <b-row>
        <!--<b-col cols="12">-->
          <!--<div-->
                  <!--v-if="isLoading"-->
                  <!--class="alert alert-info">{{$t('alerts.loading')}}...</div>-->
          <!--<div-->
                  <!--v-if="deletedItem"-->
                  <!--class="alert alert-success">{{ deletedItem['brandTitle'] }} deleted.</div>-->
          <!--<div-->
                  <!--v-if="error"-->
                  <!--class="alert alert-danger">{{ error }}</div>-->
        <!--</b-col>-->
        <b-col>
          <b-row>
            <b-col class="text-right">
              <router-link
                :to="{ name: 'EXCMDeviceModelCreate' }"
                class="btn btn-primary">{{$t('buttons.create')}}</router-link>
            </b-col>
          </b-row>
          <b-card>

          <template v-slot:header v-if="items.length > 0">
            <b-row>
              <b-col class="text-right">
                <b-button class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.excmdevicemodel_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-collapse id="excmdevicemodel_search_collapse" class="mt-2">
                  <DeviceModelsFiltering :getPage="getPage"></DeviceModelsFiltering>
                </b-collapse>
              </b-col>
            </b-row>
          </template>
          <div class="card-body">
          <Loader v-if="isLoading" size="lg"></Loader>
          <div v-else>
            <div v-if="items.length >0">
              <table class="table table-sm table-striped table-hover">
                <thead>
                <tr>
                  <th>{{$t('views.excmdevicemodel.list.model')}}</th>
                  <th>{{$t('views.excmdevicemodel.list.deviceBrand')}}</th>
                  <th>{{$t('views.excmdevicemodel.list.deviceType')}}</th>
                  <th colspan="1" />
                </tr>
                </thead>
                <tbody>
                <tr
                        v-for="item in items"
                        :key="item['@id']">
                  <td>
                    {{ item.model }}
                  </td>
                  <td>
                    <span v-if="item.idDeviceBrand">{{item.idDeviceBrand.brandTitle}}</span>
                  </td>
                  <td>
                    <span v-if="item.idDeviceType">{{item.idDeviceType.title}}</span>
                  </td>
                  <td>
                    <div class="btn-group float-right">
                      <router-link :to="{name: 'EXCMDeviceModelShow', params: { id: item['@id'] }}">
                        <button class="float-right btn btn-link fa fa-search" v-b-tooltip.hover :title="$t('buttons.show')" aria-hidden="true" />
                      </router-link>
                      <router-link :to="{name: 'EXCMDeviceModelUpdate', params: { id: item['@id'] }}">
                        <button class="float-right btn btn-link fa fa-pencil" v-b-tooltip.hover :title="$t('buttons.edit')" aria-hidden="true" />
                      </router-link>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <p v-else>{{ $t('views.excmdevicemodel.list.noDeviceModel') }}</p>
          </div>
          </div>
          </b-card>
            <div v-if="view">
              <pagination
                :view="view"
                @getPage="getPage($event)"
              ></pagination>
            </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import DeviceModelsFiltering from './components/DeviceModelsFiltering/DeviceModelsFiltering'
import Loader from '../../Layout/Loader'
import Pagination from '../../Layout/Pagination'

export default {
  components: {
    DeviceModelsFiltering,
    Loader,
    Pagination
  },

  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters({
      deletedItem: 'excmdevicemodel/del/deleted',
      error: 'excmdevicemodel/list/error',
      items: 'excmdevicemodel/list/items',
      isLoading: 'excmdevicemodel/list/isLoading',
      view: 'excmdevicemodel/list/view'
    })
  },

  created () {
    this.getPage()
  },

  beforeCreate () {
    checkPagePermission('devices', 'EXCMDeviceModelList')
  },

  methods: mapActions({
    getPage: 'excmdevicemodel/list/default'
  })
}
</script>
